import type { OnDestroy, OnInit } from '@angular/core';
import { Directive, TemplateRef } from '@angular/core';
import { Sidebar } from './sidebar.service';

@Directive({ selector: '[flSidebarHeading]' })
export class SidebarHeadingDirective implements OnInit, OnDestroy {
  constructor(
    private templateRef: TemplateRef<any>,
    private sidebar: Sidebar,
  ) {}

  ngOnInit(): void {
    this.sidebar.setHeading(this.templateRef);
  }

  ngOnDestroy(): void {
    this.sidebar.setHeading(undefined);
  }
}
